import React from 'react';
import { ApiFilterOperation } from '@eas/common-web';
import { useReturnDialog } from '@modules/es-file/dialog-actions/return/return-hook';
import { Agenda, EsFileState } from '@enums';

export function Toolbar() {
  const { ReturnButton } = useReturnDialog(Agenda.PLENARY_OPINION, [
    {
      field: 'state.id',
      operation: ApiFilterOperation.EQ,
      value: EsFileState.CLOSED,
    },
    {
      field: 'agenda.id',
      operation: ApiFilterOperation.EQ,
      value: Agenda.PLENARY_OPINION,
    },
  ]);

  return <ReturnButton />;
}
